import axios from "axios";

// One enrollment scenario per project, versioned (active + activeCopy/pending).
const getEnrollmentScenario = () =>
  axios.get("api/v1/enrollment-scenario-managements");

// Read-only ACTIVE graph for the invite form (accessible to project managers, not just admins).
const getEnrollmentScenarioForm = () =>
  axios.get("api/v1/enrollment-scenario-managements/form");

// Save the draft graph (downgrades activeCopy -> pending).
const updateScenarioVersion = (versionId, params) =>
  axios.put(`api/v1/enrollment-scenario-managements/version/${versionId}`, params);

// Activate the pending draft (Save). Reconciles fields, publishes change-trails.
const activateScenario = (versionId) =>
  axios.put(`api/v1/enrollment-scenario-managements/version/${versionId}/activate`);

// Discard the pending draft back to the active version.
const discardScenarioChanges = (versionId) =>
  axios.put(`api/v1/enrollment-scenario-managements/version/${versionId}/discard`);

const ApiEnrollmentScenarioManagement = {
  getEnrollmentScenario,
  getEnrollmentScenarioForm,
  updateScenarioVersion,
  activateScenario,
  discardScenarioChanges,
};

export default ApiEnrollmentScenarioManagement;
